import { render, staticRenderFns } from "./requestInfo.vue?vue&type=template&id=33983b88&"
import script from "./requestInfo.vue?vue&type=script&lang=js&"
export * from "./requestInfo.vue?vue&type=script&lang=js&"
import style0 from "./requestInfo.vue?vue&type=style&index=0&id=33983b88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports